if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			
			const watchInput = this.form.querySelector('[name="selling_plan"]');
			if (watchInput) {
				const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
				Object.defineProperty(watchInput, 'value', {
					set(v) {
						console.trace('🚨 selling_plan value змінюється на:', v);
						descriptor.set.call(this, v);
					},
					get() {
						return descriptor.get.call(this);
					}
				});
			}
      //this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartDrawer = document.querySelector('cart-drawer')

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          const cartHTML = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');

          // Set the description before the drawer opens and focus moves,
          // so the screen reader reads it as part of the same focus
          // announcement instead of racing a separate live-region update.
          if (window.cartStrings && response.product_title) {
            setCartLiveRegionMessage(
              window.cartStrings.itemAdded
                .replace('[title]', response.product_title)
                .replace('[quantity]', response.quantity)
            )
          }

          this.cartDrawer.renderCart(cartHTML, true);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
